import type { Identifier } from "ra-core";

export type ScriptStep = { title: string; text: string };
export type ScriptObjection = { key: string; title: string; answer: string };
export type Script = {
  id: Identifier;
  title: string;
  stage: string | null;
  steps: ScriptStep[];
  objections: ScriptObjection[];
  active: boolean;
  updated_at?: string;
};

/** The script for a lead: one made for its stage, else one for any stage */
export const scriptForStage = (
  scripts: Script[],
  stage: string | null | undefined,
) =>
  scripts.find((s) => s.active && s.stage === stage) ??
  scripts.find((s) => s.active && s.stage == null) ??
  null;

/** "{ім'я}" in a script line becomes the lead's first name */
export const fillScript = (text: string, firstName?: string | null) =>
  text.replace(/\{ім['’]я\}|\{name\}/gi, firstName?.trim() || "…");
